import { useRef, useState } from 'react';
import WebUniversal, { getService, WebUniversalProps } from '../../system/WebUniversal';
import SmsNotificationConfigEdit from './SmsNotificationConfigEdit';
import { columnsheadId } from '../../../utilsTsx/components/system/columnshead';
import { Button, Modal, Form, Input } from 'antd';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import antdMessage from '../../../utilsTsx/components/system/antdMessage';

/**
 * 组件
 * @param props
 * @returns
 */
const SmsNotificationConfig = (props: any) => {
    const apiId = 'smsNotificationConfig';
    /** 可使用WebUniversal(父)组件函数 */
    const ref = useRef<any>(undefined);

    /** 测试弹窗状态 */
    const [testOpen, setTestOpen] = useState(false);
    const [testLoading, setTestLoading] = useState(false);
    const [currentId, setCurrentId] = useState<any>(null);
    const [form] = Form.useForm();

    /** 打开测试弹窗 */
    const openTest = (id: any) => {
        setCurrentId(id);
        form.resetFields();
        setTestOpen(true);
    };

    /** 提交测试 */
    const submitTest = async () => {
        try {
            const values = await form.validateFields();
            setTestLoading(true);
            const res = await fetchApi.POST(getService('business'), {
                body: {
                    apiId: 'smsNotificationConfig',
                    apiExtend: 'sendNotifyMsg',
                    apiData: {
                        smsNotifyModeId: currentId,
                        phoneNumbers: values.phoneNumbers,
                        contents: values.contents
                    }
                }
            });
            if (res.success) {
                antdMessage('success', '测试成功', { description: res?.data });
                setTestOpen(false);
            } else {
                antdMessage('error', res.message || '测试失败');
            }
        } catch (e) {
            // 表单校验失败，忽略
        } finally {
            setTestLoading(false);
        }
    };

    /** 表头内容 */
    const columnsHead = [
        {
            title: '通知模式',
            dataIndex: 'smsNotificationMode',
            render: (val: any) => (val ? val.name : '')
        },
        {
            title: '短信服务',
            dataIndex: 'smsService',
            render: (val: any) => (val ? val.serviceName : '')
        },
        {
            title: '测试',
            dataIndex: 'id',
            render: (val: any) => (
                <Button onClick={() => openTest(val)}>测试</Button>
            )
        }
    ];

    /**
     * 表头
     */
    const columns = columnsheadId.concat(columnsHead as []);

    /**
     * 扩展Props
     */
    const extendProps: WebUniversalProps = {
        ...props,
        titleName: '短信通知配置',
        apiId,
        columns,
        serviceId: 'business',
        editOptions: {
            Editor: SmsNotificationConfigEdit
        }
    };

    return (
        <>
            <WebUniversal {...extendProps} ref={ref} />

            <Modal
                title="测试短信通知"
                open={testOpen}
                onOk={submitTest}
                confirmLoading={testLoading}
                onCancel={() => setTestOpen(false)}
                okText="发送"
                cancelText="取消"
            >
                <Form form={form} layout="vertical">
                    <Form.Item
                        name="phoneNumbers"
                        label="手机号"
                        rules={[{ required: true, message: '请输入手机号' }]}
                    >
                        <Input placeholder="请输入手机号，多个用逗号分隔" />
                    </Form.Item>
                    <Form.Item
                        name="contents"
                        label="内容"
                        rules={[{ required: true, message: '请输入短信内容' }]}
                    >
                        <Input.TextArea rows={4} placeholder="请输入短信内容" />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default SmsNotificationConfig;